import { render, staticRenderFns } from "./valueclinicalevaluation.vue?vue&type=template&id=c2892106&"
import script from "./valueclinicalevaluation.vue?vue&type=script&lang=js&"
export * from "./valueclinicalevaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports